export default {"src":"/_next/static/media/login_black.5987b720.svg","height":55,"width":176,"blurWidth":0,"blurHeight":0};